export const CurrencyValues: Record<CurrencyCode, CurrencySymbol> = {
  EUR: '€',
  MXN: 'MXN',
  USD: '$',
  BRL: 'R$',
};

export type CurrencyCode = 'EUR' | 'MXN' | 'USD' | 'BRL';
export type CurrencySymbol = '€' | 'MXN' | '$' | 'R$';
